var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { InfoModalComponent } from "../../views/modal/info_modal.component";
import { MailService } from "../mail.service";
import { AlertComponent } from "../../views/modal/alert.component";
import { PromptComponent } from "../../views/modal/prompt.component";
import { TranslateService } from "../../translate";
import { ModalService } from "../../views/modal/base_modal.component";
import { NotificationsService } from "angular2-notifications";
import { FilterComponent } from "./modals/filter.component";
var MailerReport = /** @class */ (function (_super) {
    __extends(MailerReport, _super);
    function MailerReport(activeModal, modalService, _translate, notifications, mailService) {
        var _this = _super.call(this, activeModal) || this;
        _this.modalService = modalService;
        _this._translate = _translate;
        _this.notifications = notifications;
        _this.mailService = mailService;
        _this.reports = [];
        return _this;
    }
    MailerReport.prototype.ok = function () {
        this.close();
    };
    MailerReport.prototype.download = function (report) {
        window.location.href = this.mailService.mailer.downloadFileRoute({
            name: report.name,
            link: report.link,
        }, 'download');
    };
    MailerReport.prototype.sendToMailer = function (report) {
        return __awaiter(this, void 0, void 0, function () {
            var me, modalRef, deliveryId, r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        // Почему тут проверка на 0, а в основном коде - 9??
                        if (report.fields.length === 0) {
                            me.modalService.open(AlertComponent, {
                                title: 'Внимание!',
                                message: 'Выберите хоть один из пунктов "Парметры выборки"'
                            });
                            return [2 /*return*/];
                        }
                        modalRef = me.modalService.open(PromptComponent, {
                            title: me._translate.__A('mails.mailer.enter delivery'),
                            question: 'Номер подготовленной в мейлере рассылки должен содержать только цифры'
                        });
                        deliveryId = '';
                        modalRef.componentInstance.onChange.subscribe(function (value) {
                            modalRef.componentInstance.errors = [];
                            if (isFinite(value.trim())) {
                                deliveryId = value.trim();
                                return;
                            }
                            modalRef.componentInstance.errors.push('Номер подготовленной в мейлере рассылки должен содержать только цифры');
                        });
                        // Ждём закрытия формы
                        return [4 /*yield*/, modalRef.result];
                    case 1:
                        // Ждём закрытия формы
                        _a.sent();
                        if (!deliveryId || deliveryId === 'c') {
                            return [2 /*return*/];
                        }
                        // Возможно тут нужно добавить проверку на ввод.
                        me.isLoading = true;
                        return [4 /*yield*/, me.mailService.mailer.post(__assign({ deliveryId: deliveryId }, report)).toPromise()];
                    case 2:
                        r = _a.sent();
                        me.isLoading = false;
                        if (r.ok) {
                            me.notifications.info('Пользователей', "\u0412\u044B\u0431\u043E\u0440\u043A\u0430 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430", { timeOut: 4000 });
                        }
                        else {
                            me.notifications.error('Пользователей', "\u0412\u044B\u0431\u043E\u0440\u043A\u0430 \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430", { timeOut: 4000 });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    MailerReport.prototype.deleteReport = function (report) {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.isLoading = true;
                        return [4 /*yield*/, me.mailService.mailer.delete({
                                reportId: report.id
                            }).toPromise()];
                    case 1:
                        _a.sent();
                        me.reports = me.reports.filter(function (r) { return r.id !== report.id; });
                        me.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    MailerReport.prototype.showFilterParams = function (report) {
        var me = this;
        me.modalService.open(FilterComponent, {
            title: report.name,
            filterParams: report.appliedFilterParam,
            sql: report.query,
        }, { size: 'hg' });
    };
    MailerReport.prototype.updateReportStatus = function (report) {
        return __awaiter(this, void 0, void 0, function () {
            var newStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newStatus = report.status === 'wait' ? 'delayed' : 'wait';
                        return [4 /*yield*/, this.mailService.mailer.put({ reportId: report.id, status: newStatus }, '/report').toPromise()];
                    case 1:
                        _a.sent();
                        report.status = newStatus;
                        return [2 /*return*/];
                }
            });
        });
    };
    MailerReport.prototype.getMailerReportClasses = function (report) {
        if (report.status === 'wait') {
            return 'fa-pause';
        }
        if (report.status === 'delayed') {
            return 'fa-play';
        }
        return '';
    };
    return MailerReport;
}(InfoModalComponent));
export { MailerReport };
